import React from 'react';
import { useParams } from 'react-router-dom';
import LiveSessionInterface from './LiveSessionInterface';

const ConsultantSessionPage = () => {
  const { sessionId } = useParams();

  return <LiveSessionInterface sessionId={sessionId} isConsultant={true} />;
};

export default ConsultantSessionPage;
